export enum OrderStateEnum {
    New =0 ,
    Approved=1,
    ApprovedManualSend=2,
    Processed = 3,
    ProcessedManual = 4,
    Invoiced=5,
    Closed =6,
    Canceled = 100,
    All=10
}
export const orderStateEnumToString = (state: OrderStateEnum)=>
{
    switch (state)
    {
        case OrderStateEnum.New: return "Nová"
        case OrderStateEnum.Approved: return "Ověřeno"
        case OrderStateEnum.ApprovedManualSend: return "Ověřeno ruční zpracování"
        case OrderStateEnum.Invoiced: return "Faktura vystavena"
        case OrderStateEnum.Closed: return "Dokončeno"
        case OrderStateEnum.Canceled: return "Zrušena"
            
        default: return "?"
    }
}